module.exports = __webpack_public_path__ + "static/media/Hero_canada_mobile_optimized_fixed.fff6a4af.webp";